import { GetB2bFullyManagedPlanContributionsOneResponse } from '@Common/types/b2b/orders';

export const fullyManagedPlanContributionsTranslations = {
  fields: {
    id: 'ID',
    b2b_campaign_id: 'Campaign ID',
    b2b_company_id: 'Company ID',
    savings_funds_request_id: 'Savings funds request ID',
    matching_contribution_id: 'Matching contribution ID',
    b2b_company_plan_id: 'Plan ID',
    b2b_fully_managed_allocation_id: 'Fully managed allocation ID',
    voluntary_deposit_fully_managed_plan_contribution_id: 'VP contribution ID',
    user_id: 'User ID',
    status: 'Status',
    contribution_type: 'Contribution type',
    total_gross_amount: 'Gross amount',
    user_currency_amount: 'Amount',
    fee_amount: 'Fee amount',
    tax_amount: 'Tax amount',
    tax_info: 'Tax info',
    paid_at: 'Paid at',
    created_at: 'Created at',
    updated_at: 'Updated at',
    user_currency: 'Currency',
  } satisfies Record<keyof GetB2bFullyManagedPlanContributionsOneResponse, string>,
  sections: {
    title: 'Fully managed plan contribution',
  },
};
